import { submitFumigationApplicationService } from "services/submitFumigationApplication.service";
import {
    FumigationSubmissionPayload,
    FumigationSubmissionResponse,
} from "services/fumigationSubmissionPayload";
import { useMutation } from "react-query";
import { AxiosError } from 'axios';

// POST /fumigation -> server sends the application email and responds with
// { data: "{ message, messageId }" }
export const useSubmitFumigationApplication = () => {

    return useMutation<FumigationSubmissionResponse, AxiosError, FumigationSubmissionPayload>(
        submitFumigationApplicationService
    );

}

export default useSubmitFumigationApplication;
